import { useMutation, useQueryClient } from '@tanstack/react-query';

import { invalidateClinicalBundle } from '../lib/invalidateSessionCaches';
import { sessionsService, type NoteWriteInput } from '../services';

import { sessionsKeys } from './useSessions';

export function useUpdateSessionNote(sessionId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: NoteWriteInput) => sessionsService.updateNote(sessionId, input),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: sessionsKeys.operation('note', sessionId) });
      // Timeline reads via the slim meta projection — invalidate that key too
      // so the rail's row reflects the new status / updatedAt without a reload.
      void qc.invalidateQueries({ queryKey: sessionsKeys.operation('note-meta', sessionId) });
      // Drawer renders from the clinical bundle — refresh so edits show live.
      invalidateClinicalBundle(qc, sessionId);
    },
  });
}
